<template lang="pug">
  .tag_container.page_container
    .page_header
      .page_header_column
        b-field
          b-input(
            placeholder="キーワードで検索"
            type="search"
            icon="search"
            rounded
            size="is-medium"
            @input="getTagList")
      .page_header_column
        b-field.tag_add
          b-input(
            v-model="inputForm.name"
            @keypress.enter.native="addTag()"
            placeholder="タグ名"
            size="is-medium"
            maxlength="30")
        b-field
          b-button(
            size="is-medium"
            type="is-info"
            :disabled="!inputForm.isCompleted"
            :loading="inputForm.isLoading"
            @click="addTag()") タグを追加する
    .tagList(v-if="tagList" v-cloak)
      b-table(
        :data="tagList"
        :bordered="table.isBordered"
        :striped="table.isStriped"
        :narrowed="table.isNarrowed"
        :loading="table.isLoading"
        :mobile-cards="table.hasMobileCards"
        :default-sort-direction="table.defaultSortDirection"
        :sort-icon="table.sortIcon"
        :sort-icon-size="table.sortIconSize"
        default-sort="id"
        hoverable
        class="tagList_table")
        b-table-column(v-slot="props" field="name" label="タグ名" sortable)
          span._name {{ props.row.name }}
        b-table-column(v-slot="props" field="edit" label="編集" width="60" centered)
          button.ui-icon-button(@click="activeModal(props.row.id, props.row.name)")
            b-icon.is-opacity(icon="edit")
        b-table-column(v-slot="props" field="delete" label="削除"  width="60" centered)
          button.ui-icon-button(@click="deleteConfirm(props.row.id, props.row.name)")
            b-icon.is-danger(icon="trash-alt")
        template(v-slot:empty v-if="!isInitialLoading")
          p._empty_message 該当するタグはありません
    //編集モーダル
    b-modal(v-model="editForm.isModalActive" :width="640")
      .modal-card
        .modal-card-head
          header タグを編集
        .modal-card-body
          b-field(label="タグ名")
            b-input(v-model="editForm.name" type="text" required size="is-medium" minlength="2" maxlength="30")
        .modal-card-foot
          b-button(type="is-info" size="is-medium" @click="updateTag()" :disabled="!editForm.isCompleted") 更新する
</template>

<script>
export default {
  name: 'Tag',
  head: {
    title() {
      return {
        inner: 'タグ',
        separator: '|',
        complement: '管理画面',
      }
    }
  },
  data: function(){
    return {
      tagList: [],
      isInitialLoading: true,

      /* 追加フォーム */
      inputForm: {
        name: '',
        id: null,
        isCompleted: false,
        isLoading: false
      },

      /* 編集フォーム */
      editForm: {
        name: '',
        id: '',
        isCompleted: false,
        isModalActive: false,
      },

      /* b-table settings */
      table: {
        isEmpty: false,
        isBordered: false,
        isStriped: false,
        isNarrowed: false,
        isLoading: false,
        hasMobileCards: true,
        defaultSortDirection: 'asc',
        sortIcon: 'arrow-up',
        sortIconSize: 'is-small',
        isPaginated: false,
      }
    }
  },
  created() {
    this.getTagList()
  },
  watch: {
    'inputForm.name'(val) {
      this.inputForm.isCompleted = ( val.length > 0 ) ? true : false
    },
    'editForm.name'(val) {
      this.editForm.isCompleted = ( val.length > 0 ) ? true : false
    }
  },
  methods: {
    activeModal(id, name){
      this.editForm.id = id
      this.editForm.name = name

      this.editForm.isModalActive = true
    },
    deleteConfirm(id, name){
      this.$buefy.dialog.confirm({
        title: name + ' を削除しますか？',
        message: 'このタグを選択している記事からも、タグが削除されます。',
        confirmText: 'タグを削除する',
        cancelText: 'キャンセル',
        type: 'is-danger',
        size: 'is-medium',
        hasIcon: true,
        icon: 'exclamation-circle',
        onConfirm: () => {
          this.deleteTag(id, name)
        }
      })
    },
    async getTagList(val) {
      try {
        this.table.isLoading = true
        const data_obj = {
          keyword: val
        }
        const res = await this.$axios.get(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.TAGS,
          { params: data_obj }
        )
        let r = res.data
        if( r.status == 1 ){
          const data = r.data
          this.tagList = data
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, 'タグ一覧の取得に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.table.isLoading = false
        this.isInitialLoading = false
      }
    },
    async addTag() {
      try {
        this.inputForm.isLoading = true
        const data_obj = {
          tag: {
            name: this.inputForm.name
          }
        }
        const data_json = JSON.stringify(data_obj)
        const config = { headers: {"Content-Type": "application/json"} }

        const res = await this.$axios.post(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.TAGS,
          data_json,
          config
        )

        const r = res.data

        if( r.status == 1 ){
          this.$common.createSuccessMessage('タグ ' + this.inputForm.name + ' を追加しました')
          this.getTagList()
          this.inputForm.name = ""
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else if( r.errors.status == 54 ) {
            this.$common.createErrorMessage(r.errors, 'このタグは既に登録されています。')
          } else if( r.errors.status == 55 ) {
            this.$common.createErrorMessage(r.errors, 'タグ名は2~30文字以内で入力してください。')
          } else {
            this.$common.createErrorMessage(r.errors, 'タグの追加に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.inputForm.isLoading = false
      }
    },
    async updateTag() {
      try {
        const data_obj = {
          tag: {
            name: this.editForm.name
          }
        }
        const data_json = JSON.stringify(data_obj)
        const config = { headers: {"Content-Type": "application/json"} }

        const res = await this.$axios.put(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.TAGS_.replace(':id', this.editForm.id),
          data_json,
          config
        )
        const r = res.data
        if( r.status == 1 ){
          this.$common.createSuccessMessage('タグ ' + this.inputForm.name + ' を更新しました')
          this.getTagList()
          this.editForm.isModalActive = false
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else if( r.errors.status == 54 ) {
            this.$common.createErrorMessage(r.errors, 'このタグは既に登録されています。')
          } else if( r.errors.status == 55 ) {
            this.$common.createErrorMessage(r.errors, 'タグ名は2~10文字以内で入力してください。')
          } else {
            this.$common.createErrorMessage(r.errors, 'タグの更新に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      }
    },
    async deleteTag(id, name) {
      try {
        const res = await this.$axios.delete(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.TAGS_.replace(':id', id)
        )
        const r = res.data
        if( r.status == 1 ){
          this.$common.createSuccessMessage(name + ' を削除しました')
          this.getTagList()
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, 'タグの削除に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      }
    },
  }
}
</script>